import { useState } from "react";
import { sendEmailRescue } from "../services/sendEmailRescue";
import { FcApproval } from "react-icons/fc";
import SpinnerOverlay from "../Components/SpinnerOverlay";

function PasswordRescue() {
    const [email, setEmail] = useState("");
    const [send, setSend] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            if (!email) return;
            setLoading(true);
            const response = await sendEmailRescue(email);
            setLoading(false);
            setSend(response.success);
            if (!response.success) {
                alert("No se pudo enviar mail");
            }
        } catch (e) {
            setLoading(false);
            console.log(e);
        }
    };
    return (
        <div className="flex flex-col items-center justify-center h-screen">
            <div className="flex flex-col items-center h-1/2 max-w-sm">
                <SpinnerOverlay isLoading={loading} />
                {send ? (
                    <>
                        <h2 className="text-3xl text-center font-bold flex items-center gap-4">
                            <FcApproval />
                            Email enviado
                        </h2>
                        <form
                            onSubmit={handleSubmit}
                            className=" flex flex-col w-full"
                        >
                            <button className="bg-yellow-cdg hover:bg-yellow-600 text-black text-500 p-3 rounded w-1/2 m-auto mt-10 ">
                                Renviar
                            </button>
                        </form>
                    </>
                ) : (
                    <>
                        <h2 className="text-3xl text-center font-bold mb-5">
                            Recuperar la contraseña
                        </h2>
                        <form
                            onSubmit={handleSubmit}
                            className=" flex flex-col w-full font-sans"
                        >
                            <input
                                type="email"
                                name="email"
                                id="email"
                                value={email}
                                placeholder="Ingrese su email"
                                onChange={(e) => setEmail(e.target.value)}
                                className=" rounded bg-zinc-800 p-3 w-full"
                            />
                            <button className="bg-yellow-cdg hover:bg-yellow-600 text-black p-3 rounded w-1/2 m-auto mt-10 ">
                                Enviar
                            </button>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}

export default PasswordRescue;
